import {
  Captcha,
  type CaptchaRef,
} from 'components/thirdParty/Captcha/Captcha';
import { useRef, useState } from 'react';
import { useTranslations } from 'utils/translations/useTranslations';
import { FacebookSignIn } from './components/FacebookSignIn/FacebookSignIn';
import { GoogleSignIn } from './components/GoogleSignIn/GoogleSignIn';

export function SocialSignIn({
  onSuccess,
  onError,
  isLogin,
}: {
  onSuccess?: () => void;
  onError: (err?: unknown) => void;
  isLogin: boolean;
}) {
  const i18n = useTranslations();
  const captchaRef = useRef<CaptchaRef>(null);
  const [captchaToken, setCaptchaToken] = useState<string | undefined>(
    undefined,
  );

  const onClickSignIn = (handleProviderSignIn: () => void) => {
    if (captchaRef?.current?.isEnabled()) {
      try {
        const result = captchaRef.current?.execute({ async: true });
        result?.then(
          () => handleProviderSignIn(),
          () => {
            // do nothing
          },
        );
      } catch (_e) {
        resetCaptcha();
      }
    } else {
      handleProviderSignIn();
    }
  };

  const handleSignInWithCaptcha = async (token: string) => {
    if (token) {
      setCaptchaToken(token);
    } else {
      onError();
    }
  };

  const resetCaptcha = () => {
    captchaRef.current?.reset();
  };

  const handleError = () => {
    resetCaptcha();
    onError();
  };

  return (
    <>
      <GoogleSignIn
        onClick={onClickSignIn}
        onSuccess={onSuccess}
        onError={onError}
        isLogin={isLogin}
        captchaToken={captchaToken}
      />

      <FacebookSignIn
        onClick={onClickSignIn}
        onSuccess={onSuccess}
        onError={onError}
        isLogin={isLogin}
        captchaToken={captchaToken}
      />

      <Captcha
        ref={captchaRef}
        onVerify={handleSignInWithCaptcha}
        onError={handleError}
        onClose={resetCaptcha}
      />

      <div className="mb-4 flex flex-row items-center justify-center gap-2 pt-1 uppercase text-gray-700">
        <div className="w-full border-b border-gray-300 text-center leading-[0.1em]">
          &nbsp;
        </div>
        <span>{i18n.t('userLogin.social.or')}</span>
        <div className="w-full border-b border-gray-300 text-center leading-[0.1em]">
          &nbsp;
        </div>
      </div>
    </>
  );
}
